export function formatTemperature(temperature) {
  if (temperature === undefined || temperature === null || Number.isNaN(temperature)) {
    return "--°C";
  }

  const symbolValue = temperature > 0 ? '+' : '';
  return `${symbolValue}${temperature}°C`;
}